var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18522 9.99957C4.18522 9.35012 4.29607 8.72709 4.4922 8.14327L1.04887 5.56934C0.357049 6.94364 -0.00221492 8.46112 1.0274e-05 9.99957C1.0274e-05 11.5917 0.376918 13.0934 1.04717 14.4264L4.48879 11.8482C4.28812 11.2525 4.18559 10.6281 4.18522 9.99957Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2329 4.09102C11.674 4.09102 12.9761 4.59047 13.9994 5.40867L16.9763 2.49979C15.1625 0.954572 12.8371 0 10.2329 0C6.18922 0 2.71348 2.26285 1.04895 5.56976L4.49399 8.14369C5.28703 5.78624 7.54848 4.09102 10.2329 4.09102Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2329 15.909C7.54762 15.909 5.28618 14.2138 4.49228 11.8563L1.04895 14.4302C2.71263 17.7372 6.18837 20 10.2329 20C12.728 20 15.1105 19.1332 16.8995 17.5079L13.6302 15.0345C12.7084 15.603 11.5469 15.909 10.232 15.909",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 9.99959C20.0005 9.40895 19.9067 8.77228 19.7677 8.18164H10.2324V12.0451H15.7206C15.4469 13.3628 14.6999 14.3753 13.6314 15.0341L16.8999 17.5075C18.7785 15.8012 20.0005 13.2596 20.0005 9.99959Z",
    fill: "#4285F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.svg";
export { ForwardRef as ReactComponent };